<script setup lang="ts">
import { computed, defineProps } from "vue";
import { ChineseCalendarDate } from "@/types/calculators";
import { WEEK_KEYS } from "@/constants/chineseCalendar";
import { useI18n } from "vue-i18n";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";

const props = defineProps<{
  chineseCalendar: ChineseCalendarDate[];
  month: number;
  year: number;
  monthKey: string;
}>();

const { t } = useI18n();

const firstDay = computed(() => {
  const startOfMonth = new Date(props.year, props.month, 1);
  const firstDayIndex = startOfMonth.getDay() - 1;
  // Sunday has 0 index that after -1 gives -1 index
  if (firstDayIndex == -1) {
    return 6;
  }
  return firstDayIndex;
});

function openFullDayInfo(date: string) {
  router.push({
    name: ROUTE_NAMES.CHINESE_CALENDAR_DAY,
    query: { date: date },
  });
}
</script>

<template>
  <div>
    <div
      class="w-full grid grid-cols-7 gap-2 px-2 pt-2 pb-4 bg-white rounded-lg"
    >
      <!-- WEEK'S NAMES -->
      <div
        v-for="weekKey in WEEK_KEYS"
        :key="weekKey"
        class="min-h-11 flex items-center justify-center"
      >
        <span class="font-semibold text-xl text-brown">
          {{ t(`week-names.${weekKey}`) }}
        </span>
      </div>

      <!-- EMPTY CELLS BEFORE -->
      <div
        v-if="firstDay && firstDay !== 0"
        :style="{ gridColumn: firstDay === -1 ? 'span 6' : `span ${firstDay}` }"
      ></div>

      <!-- CHINESE CALENDAR -->
      <div
        v-for="(chineseDay, index) in chineseCalendar"
        :key="chineseDay.date"
        class="flex items-center justify-center min-h-8 relative group"
        @click="openFullDayInfo(chineseDay.date)"
      >
        <div
          class="h-full aspect-square rounded-full group-hover:bg-active group-active:bg-[#FDB695] absolute opacity-0 group-hover:opacity-100 group-active:opacity-100"
        ></div>
        <span
          class="text-brown group-hover:text-white group-active:text-white font-normal text-base leading-[20px] z-10"
        >
          {{ index + 1 }}
        </span>
      </div>
    </div>
  </div>
</template>
